import React, { useEffect, useState } from "react";
import { API_BASE_URL } from "src/config/apiBase";
import { decryptToken } from "../utils/getToken";
import { toast } from "react-toastify";
import { Calendar, Link2, Unlink } from "lucide-react";
import { useSearchParams } from "react-router-dom";

const CrmGoogleCalendarPanel = () => {
  const [status, setStatus] = useState(null);
  const [params] = useSearchParams();
  const url = API_BASE_URL;
  const token = decryptToken("accessToken") || "";

  const load = () => {
    fetch(`${url}/leads/google-calendar/status`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((r) => (r.ok ? r.json() : null))
      .then(setStatus)
      .catch(() => setStatus(null));
  };

  useEffect(() => {
    load();
    const cal = params.get("calendar");
    if (cal === "connected") toast.success("Google Calendar connected");
    if (cal === "error") toast.error("Google Calendar connection failed");
  }, [url, token, params]);

  const connect = async () => {
    const res = await fetch(`${url}/leads/google-calendar/auth-url`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    const data = await res.json();
    if (!res.ok) {
      toast.error(data.message || "OAuth not configured");
      return;
    }
    window.location.href = data.url;
  };

  const disconnect = async () => {
    await fetch(`${url}/leads/google-calendar`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    });
    load();
    toast.info("Google Calendar disconnected");
  };

  return (
    <div className="crm-gcal-panel">
      <div className="crm-integrations__head">
        <strong>Google Calendar sync</strong>
        {status?.connected ? (
          <button type="button" onClick={disconnect}>
            <Unlink size={14} /> Disconnect
          </button>
        ) : (
          <button type="button" onClick={connect} disabled={!status?.configured}>
            <Link2 size={14} /> Connect
          </button>
        )}
      </div>
      <p className="crm-insights__muted">
        Two-way sync: CRM reminders create/update events on your Google Calendar when connected.
      </p>
      {!status?.configured && (
        <p className="crm-gcal-panel__warn">
          Set <code>GOOGLE_CALENDAR_CLIENT_ID</code> and <code>GOOGLE_CALENDAR_CLIENT_SECRET</code> on the backend.
        </p>
      )}
      {status?.connected && (
        <p className="crm-gcal-panel__ok">
          <Calendar size={14} /> Connected — calendar: {status.calendarId}
        </p>
      )}
    </div>
  );
};

export default CrmGoogleCalendarPanel;
